import { Text, UnstyledButton } from '@mantine/core';

type TaskTitlePropsType = {
  title: string;
  isClosed?: boolean;
  onClick: () => void;
};

export const TaskTitle: React.FC<TaskTitlePropsType> = ({
  title,
  isClosed = false,
  onClick,
}) => {
  return (
    <UnstyledButton
      onClick={onClick}
      flex={1}
      miw={0}
      style={{ textAlign: 'left' }}
      aria-label={title}
    >
      <Text
        c={isClosed ? 'text.6' : 'text.4'}
        size="sm"
        fw={600}
        lh={1.35}
        style={isClosed ? { textDecoration: 'line-through' } : undefined}
      >
        {title}
      </Text>
    </UnstyledButton>
  );
};
